<template>
  <!-- Boost rewards -->
  <div class="grid lg:grid-cols-5 gap-4 md:grid-cols-5 sm:grid-cols-1">
    <div class="col-span-2">
      <h5 class="font-semibold text-grey-light-900">Boost Rewards</h5>
      <p class="text-grey-light-600 text-sm">Configure the Boost Rewards options you’d like to offer your customers.</p>
    </div>
    <div class="col-span-2">
      <div class="flex flex-col gap-4">
        <FormField v-slot="{ value, handleChange }" name="boostSettings.allowVoucher">
          <FormItem class="flex gap-2 items-center">
            <FormControl>
              <SwitchComponent :model-value="value" @update:model-value="handleChange" />
            </FormControl>
            <FormLabel class="!mt-0">Allow Voucher</FormLabel>
          </FormItem>
        </FormField>
        <div v-if="form.values.boostSettings.allowVoucher" class="grid grid-cols-5 gap-4">
          <div class="col-span-5">
            <FormField v-slot="{ value, handleChange }" name="boostSettings.minSavingGoal">
              <FormItem>
                <FormControl>
                  <CurrencyInput
                    :modelValue="value"
                    @update:modelValue="handleChange"
                    :min="0"
                    :max="10000000"
                    label="Minimum Saving Goal"
                    :hide-error="true"
                  />
                </FormControl>
                <FormMessage />
              </FormItem>
            </FormField>
          </div>
          <div class="col-span-5">
            <FormField v-slot="{ value, handleChange }" name="boostSettings.maxSavingGoal">
              <FormItem>
                <FormControl>
                  <CurrencyInput
                    :modelValue="value"
                    @update:modelValue="handleChange"
                    :min="0"
                    :max="10000000"
                    label="Maximum Saving Goal"
                    :hide-error="true"
                  />
                </FormControl>
                <FormMessage />
              </FormItem>
            </FormField>
          </div>
          <div class="col-span-3">
            <FormField v-slot="{ componentField }" name="boostSettings.rewardType">
              <FormItem>
                <FormLabel>Reward Type</FormLabel>
                <Select v-bind="componentField">
                  <FormControl>
                    <SelectTrigger>
                      <SelectValue placeholder="Select the reward type" />
                    </SelectTrigger>
                  </FormControl>
                  <SelectContent>
                    <SelectGroup>
                      <SelectItem value="FLAT">Flat</SelectItem>
                      <SelectItem value="PERCENTAGE">Percentage</SelectItem>
                    </SelectGroup>
                  </SelectContent>
                </Select>
              </FormItem>
            </FormField>
          </div>
          <div class="col-span-2">
            <FormField
              v-if="form.values.boostSettings.rewardType === 'FLAT'"
              v-slot="{ value, handleChange }"
              name="boostSettings.rewardFlatFee"
            >
              <FormItem>
                <FormControl>
                  <CurrencyInput
                    :modelValue="value"
                    @update:modelValue="handleChange"
                    :min="0"
                    :max="10000000"
                    label="Flat Fee Amount"
                    :hide-error="true"
                  />
                </FormControl>
                <FormMessage />
              </FormItem>
            </FormField>
            <FormField
              v-if="form.values.boostSettings.rewardType === 'PERCENTAGE'"
              v-slot="{ componentField }"
              name="boostSettings.rewardPercentage"
            >
              <FormItem>
                <FormLabel>Select Percentage</FormLabel>
                <Select v-bind="componentField">
                  <FormControl>
                    <SelectTrigger>
                      <SelectValue placeholder="Select Percentage" />
                    </SelectTrigger>
                  </FormControl>
                  <SelectContent>
                    <SelectGroup>
                      <SelectItem v-for="i in 100" :key="i" :value="i.toString()">{{ i }}</SelectItem>
                    </SelectGroup>
                  </SelectContent>
                </Select>
                <FormMessage />
              </FormItem>
            </FormField>
          </div>
          <div class="col-span-5">
            <FormField v-slot="{ componentField }" name="boostSettings.rewardProvider">
              <FormItem>
                <FormLabel>Select Provider</FormLabel>
                <Select v-bind="componentField">
                  <FormControl>
                    <SelectTrigger>
                      <SelectValue placeholder="Select Provider" />
                    </SelectTrigger>
                  </FormControl>
                  <SelectContent>
                    <SelectGroup>
                      <SelectItem value="SHOPIFY">Shopify</SelectItem>
                    </SelectGroup>
                  </SelectContent>
                </Select>
                <FormMessage />
              </FormItem>
            </FormField>
            <div v-if="form.values.boostSettings.rewardProvider === 'SHOPIFY'" class="mt-2">
              <p class="text-sm">Please install our <a class="text-brand-600" :href="'#'">Shopify Voucher App</a></p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <SectionDivider class="my-4" />
</template>

<script setup lang="ts">
import CurrencyInput from '@/components/common/CurrencyInput.vue';
import { FormControl, FormField, FormItem, FormLabel, FormMessage } from '@/components/ui/form';
import { Select, SelectContent, SelectGroup, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import SwitchComponent from '@/components/ui/switch/SwitchComponent.vue';
import { type FormContext } from 'vee-validate';

defineProps<{ form: FormContext<any, any> }>();
</script>
